module.exports = __webpack_public_path__ + "static/img/TA900.41e251e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/problem/TA900.png
// module id = 8Czk
// module chunks = 0